module.exports = __webpack_public_path__ + "static/img/torso8.e05ee338.jpg";